    import React, { useState } from 'react';
    import { auth } from './../firebase';
    import { signInWithEmailAndPassword } from 'firebase/auth';
    import { useNavigate } from 'react-router-dom';

    export const Login = () => {
      const [email, setEmail] = useState('');
      const [password, setPassword] = useState('');
      const [error, setError] = useState('');
      const navigate = useNavigate(); // Hook for navigation

      const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
          const userCredential = await signInWithEmailAndPassword(auth, email, password);
          if ( userCredential.user )
          {
            navigate('/dashboard');
          }
        } catch (err) {
          setError(err.message);
        }
      };

      return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100">
          <div className="col-md-6 col-lg-4">
              <div className="card shadow p-4">
                  <h2 className="text-center mb-4">Inicio de Sesión</h2>
                  {error && <p style={{ color: 'red' }}>{error}</p>}
                  <form onSubmit={handleLogin}>
                      <div className="mb-3">
                          <label className="form-label">E-mail</label>
                          <input
                            className="form-control" id="emailInput" aria-describedby="emailHelp"
                            type="email"
                            placeholder="Ingresa tu E-mail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                          <div id="emailHelp" className="form-text">Nunca compartiremos tu mail con nadie.</div>
                      </div>
                      <div className="mb-3">
                          <label className="form-label">Contraseña</label>
                          <input
                            className="form-control" id="passwordInput" 
                            type="password"
                            placeholder="Ingresa tu Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                      </div>
                      <button type="submit" className="btn btn-primary w-100">Entrar</button>
                  </form>
              </div>
          </div>
      </div>
      );
    };